import React, { Component } from "react";
import { isMobile } from "react-device-detect";
import MobileHeader from "./Header/";
import DesktopHeader from "./Nav/Navbar";

export default class GlobalError extends Component {
  render() {
    const { message, title } = this.props;
    return (
      <React.Fragment>
        {(isMobile && <MobileHeader />) || <DesktopHeader />}
        <div className="container we-right-back">
          <h4>{(title && title) || "We’ll be right back!"}</h4>
          <p>
            {(message && message) ||
              "Sorry, we're really busy at the moment so we're unable to take any more orders in your area for now.\n" +
                "Please check back in a few minutes."}
          </p>
          <div className="svg">
            <img src="/png/we-right.png" alt="" />
          </div>
          <a
            href="javascript: void(0)"
            onClick={() => location.reload(true)}
            className="btn btn-blue"
          >
            Retry
          </a>
        </div>
      </React.Fragment>
    );
  }
}
